import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loading: {
    id: 'views.Robot.Catalog.loading',
    defaultMessage: 'Cargando...'
  }
});
